<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      cell-class-name="align-top"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.imageUrl ? $osscdn(row.imageUrl) : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.imageUrl
              ? $osscdn(row.imageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:fabricName="{ row }">
        <span>{{ row.fabricNo }}</span>
        <br v-if="row.fabricNo" />
        <span>{{ row.fabricName }}</span>
        <br />
        <span>成分：{{ row.fabricContent }}</span>
      </template>

      <template v-slot:widAndWeight="{ row }">
        <span>克重：{{ row.fabricWeight }} {{ row.fabricWeightUnit }}</span>
        <br />
        <span>门幅：{{ row.fabricWid }} {{ row.widUnit }}</span>
      </template>
      <template v-slot:fabricColor="{ row }">
        <span>颜色：{{ row.colorName || '' }}</span>
        <br />
        <span v-if="row.ftyNo && row.scmColorNo"
          >编号：{{ row.ftyNo || '' }}-{{ row.scmColorNo || '' }}</span
        >
        <span v-else> {{ row.ftyNo || '' }}{{ row.scmColorNo || '' }} </span>
      </template>
      <template v-slot:fabricScm="{ row }">
        <span>{{ row.scmName || '' }}</span>
        <br />
        <span>{{ row.resFabricScmName || '' }} </span>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.resFabricDemandStatus === 'Y'
              ? 'success'
              : row.resFabricDemandStatus === 'P'
              ? 'warning'
              : row.resFabricDemandStatus === 'C'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_resFabricDemandStatus }}
        </el-tag>
      </template>
      <template v-slot:unitPrice="{ row }">
        <span>数量：{{ row.demandQty || '' }}米</span>
        <br />
        <span>单价：{{ row.unitPrice || '' }}元</span>
      </template>
      <template v-slot:demandAmount="{ row }">
        <span>{{ row.demandAmount || '' }}元</span>
      </template>
      <template v-slot:resFabricDemandNo="{ row }">
        <span>{{ row.resFabricDemandNo }}</span>
        <br />
        <span>{{ row.demandPersonName }}</span>
        <br />
        <span>{{ row.demandDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {},
}
</script>
